import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_tecnicos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaPhone } from "react-icons/fa6";
import "../../pages/admin/css/Dashboard.css";
import { API_BASE_URL } from "../../config/apiConfig";

const FormularioCita = ({
  onClose,
  onGuardar,
  dniPorDefecto = "",
  asuntoPorDefecto = "",
}) => {
  const [newEvent, setNewEvent] = useState({
    title: asuntoPorDefecto,
    user: dniPorDefecto,
    date: "",
    startTime: "",
    endTime: "",
  });

  const handleGuardar = () => {
    onGuardar(newEvent);
    onClose();
  };

  return (
    <div className="accesos-directos-tarjeta historico-seguimiento solicita-cita">
      <div className="modal-content">
        <div className="modal-header mayusculas">
          <h3>Agendar cita</h3>
        </div>
        <div className="modal-body mt-10 negro">
          <p>
            <strong>Usuario (DNI):</strong> {newEvent.user}
          </p>
          <p>
            <strong>Asunto:</strong> {newEvent.title}
          </p>
          <div className="flex gap-50 mt-20 ">
            <div>
              <p>
                <strong>Fecha:</strong>
              </p>
              <input
                type="date"
                onChange={(e) =>
                  setNewEvent({ ...newEvent, date: e.target.value })
                }
              />
            </div>
            <div>
              <p>
                <strong>Hora (inicio y fin):</strong>
              </p>
              <div className="flex gap-20">
                <input
                  type="time"
                  onChange={(e) =>
                    setNewEvent({ ...newEvent, startTime: e.target.value })
                  }
                />{" "}
                -
                <input
                  type="time"
                  onChange={(e) =>
                    setNewEvent({ ...newEvent, endTime: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
          <div className="botones flex end gap-10 mt-20">
            <button className="boton" onClick={onClose}>
              Cancelar
            </button>
            <button className="boton" onClick={handleGuardar}>
              Agendar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const AsignarCitas = () => {
  const { user, role } = useSelector((state) => state.auth);
  const [citas, setCitas] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(null);

  useEffect(() => {
    const fetchCitas = async () => {
      try {
        // 1. Obtener todos los técnicos
        const res = await fetch(`${API_tecnicos}`);
        const data = await res.json();

        // 2. Buscar al técnico logueado
        const tecnico = data.find(
          (t) =>
            t.email === user?.email ||
            (t.name?.toLowerCase() === user?.name?.toLowerCase() &&
              t.role === role)
        );

        if (!tecnico) return;

        // 3. Obtener sus citas
        const resCitas = await fetch(`${API_tecnicos}/${tecnico.id}/citas`);
        const citasData = await resCitas.json();

        // 4. Filtrar citas asignadas
        const citasAsignadas = citasData.filter(
          (cita) => cita.state?.toLowerCase() === "asignado" //esto es asignado
        );

        setCitas(citasAsignadas);
      } catch (error) {
        console.error("Error al obtener citas del técnico:", error);
      }
    };

    if (user && role) {
      fetchCitas();
    }
  }, [user, role]);

  const handleGuardarCita = async (evento) => {
    const cita = citas.find(
      (c) => c.dni === evento.user && c.subject === evento.title
    );
    if (!cita) return;

    const fechaISO = new Date(
      `${evento.date}T${evento.startTime}`
    ).toISOString();

    try {
      await fetch(`${API_BASE_URL}/aceptarCita/${cita.appointmentId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          appointmentDate: fechaISO,
          state: "aceptado",
        }),
      });
      setMostrarFormulario(null);
      setCitas((prev) =>
        prev.filter((c) => c.appointmentId !== cita.appointmentId)
      );

      toast.success("¡Cita agendada!");
    } catch (error) {
      console.error("Error al aceptar cita:", error);
      toast.error("Hubo un error al agendar la cita.");
    }
  };

  return (
    <div className={`citas ${citas.length === 0 ? "none" : ""}`}>
      <h1 className="mayusculas">CITAS PENDIENTES DE AGENDAR</h1>

      {citas.map((cita) => (
        <div key={cita.appointmentId} className="proxima-cita rojo column">
          <p className="asunto bold mt-5 negro">{cita.name}</p>
          <p className="asunto mb-5 negro">{cita.dni}</p>
          <p className="asunto mb-10 negro align-center gap-5">
            {" "}
            <FaPhone /> {cita.phone}
          </p>
          <p className="asunto mt-5 negro">{cita.subject}</p>
          <button
            className="mt-10 rojo fondo-blanco no-border text-left"
            onClick={() => setMostrarFormulario(cita)}
          >
            Agendar ahora
          </button>

          {mostrarFormulario?.appointmentId === cita.appointmentId && (
            <FormularioCita
              onClose={() => setMostrarFormulario(null)}
              onGuardar={handleGuardarCita}
              dniPorDefecto={cita.dni}
              asuntoPorDefecto={cita.subject}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default AsignarCitas;
